
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/volunteer/sadhanapada",
      function () {
        return require("private-next-pages/[region]/[language]/volunteer/sadhanapada/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/volunteer/sadhanapada"])
      });
    }
  